import { Model as s } from "../../../../../../model.js";
class i extends s {
  constructor(t) {
    super(), this.minSourceUnits = t.minSourceUnits, this.targetUnits = t.targetUnits, this.balanceCap = t.balanceCap;
  }
}
export {
  i as TierConversionRuleModel
};
//# sourceMappingURL=tierConversionRule.model.js.map
